/**
 * 员工状态公共常量
 */
export const STAFF_STATUS = Object.freeze({
  options: ["正式", "试用期", "已离职", "待离职"],
});

